//data-categories
class Categories {
    constructor(el) {
        this.scope = el;
        this.triggers = el.querySelectorAll("[data-category-target]");
        this.showAllTrigger = el.querySelectorAll("[data-category-all]");
        this.bindEvents();
    }

    bindEvents() {
        this.triggers.forEach(target => {
            target.addEventListener("click", () => this.toggleCategory(target));
        })

        this.showAllTrigger.forEach(el => {
            this.showAll(el);
            el.addEventListener("click", () => this.showAll(el));
        })
    }

    showAll(el) {
        if (el.getAttribute("data-active")) {
            el.removeAttribute("data-active");
            el.classList.add("button--2");
            el.classList.remove("button--3");
            this.toggleSections();
        } else {
            el.setAttribute("data-active", "true");
            el.classList.remove("button--2");
            el.classList.add("button--3");
            this.UnselectCategories();
            this.showAllSections();
        }
    }

    UnselectShowAllOption() {
        this.showAllTrigger.forEach(el => {
            if (el.getAttribute("data-active")) {
                el.removeAttribute("data-active");
                el.classList.add("button--2");
                el.classList.remove("button--3");
            }
        });
    }

    UnselectCategories() {
        this.triggers.forEach(el => {
            if (el.getAttribute("data-active")) {
                el.removeAttribute("data-active");
                el.classList.add("button--2");
                el.classList.remove("button--3");
            }
        });
    }

    toggleCategory(el) {
        this.UnselectShowAllOption();

        if (el.getAttribute("data-active")) {
            el.removeAttribute("data-active");
            el.classList.add("button--2");
            el.classList.remove("button--3");
        } else {
            el.setAttribute("data-active", "true");
            el.classList.remove("button--2");
            el.classList.add("button--3");
        }
        this.toggleSections();
    }

    toggleSections() {
        if (this.scope.querySelectorAll('[data-category-target][data-active]').length > 0) {
            this.triggers.forEach(trigger => {
                const category = trigger.getAttribute("data-category-target");
                const target = document.querySelector(`[data-category-content="${category}"]`);
                if (trigger.getAttribute("data-active")) {
                    target && this.showSection(target);
                } else {
                    target && this.hideSection(target);
                }
            })
        } else {
            this.showAllTrigger.forEach(el => {
                this.showAll(el);
            })
        }
    }

    showSection(section) {
        section.classList.remove("hidden");
    }

    hideSection(section) {
        section.classList.add("hidden");
    }

    showAllSections() {
        document.querySelectorAll("[data-category-content]")
            .forEach(section => {
                
                const count = [...section.querySelectorAll("[data-result]")]
                    .filter(x => x.dataset.show !== "true" === false)
                    .length;
                
                if (count > 0)
                {
                    this.showSection(section);    
                }
                else
                {
                    this.hideSection(section);
                }
            });
    }
}

document.querySelectorAll('[data-categories]').forEach(el => {
    new Categories(el);
})